import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class UpdateCurrentUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Repository} deps.cookieUserRepository
   */
  constructor({cookieUserRepository}) {
    super()

    this._cookieUserRepository = cookieUserRepository
  }

  /**
   * @return {Promise<Object, Error>} returns current logged user
   * @property {Request} updateCurrentUserRequest
   */
  execute({shouldReadUpdatedVO, updateCurrentUserRequest}) {
    return this._cookieUserRepository.updateCurrentUser({
      shouldReadUpdatedVO,
      updateCurrentUserRequest
    })
  }
}
